import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import { useLanguage } from '../../../contexts/LanguageContext';

const LegalSection = () => {
  const { t } = useLanguage();
  const [activeSection, setActiveSection] = useState('privacy');

  const legalSections = [
    { id: 'privacy', label: t('legal.privacyPolicy'), icon: 'Shield' },
    { id: 'terms', label: t('legal.termsOfService'), icon: 'FileText' },
    { id: 'cookies', label: t('legal.cookiePolicy'), icon: 'Cookie' },
    { id: 'data', label: t('legal.dataProtection'), icon: 'Lock' }
  ];

  const renderContent = () => {
    switch (activeSection) {
      case 'privacy':
        return (
          <div className="space-y-6">
            <h3 className="text-2xl font-bold text-[#111827]">{t('legal.privacyPolicy')}</h3>
            <p className="text-[#6B7280] leading-relaxed">
              {t('legal.lastUpdated')}
            </p>
            <div className="space-y-4">
              <div>
                <h4 className="text-lg font-semibold text-[#111827] mb-2">{t('legal.privacySection1Title')}</h4>
                <p className="text-[#6B7280] leading-relaxed">
                  {t('legal.privacySection1Desc')}
                </p>
              </div>
              <div>
                <h4 className="text-lg font-semibold text-[#111827] mb-2">{t('legal.privacySection2Title')}</h4>
                <p className="text-[#6B7280] leading-relaxed">
                  {t('legal.privacySection2Desc')}
                </p>
              </div>
              <div>
                <h4 className="text-lg font-semibold text-[#111827] mb-2">{t('legal.privacySection3Title')}</h4>
                <p className="text-[#6B7280] leading-relaxed">
                  {t('legal.privacySection3Desc')}
                </p>
              </div>
              <div>
                <h4 className="text-lg font-semibold text-[#111827] mb-2">{t('legal.privacySection4Title')}</h4>
                <p className="text-[#6B7280] leading-relaxed">
                  {t('legal.privacySection4Desc')}
                </p>
              </div>
            </div>
          </div>
        );
      case 'terms':
        return (
          <div className="space-y-6">
            <h3 className="text-2xl font-bold text-[#111827]">{t('legal.termsOfService')}</h3>
            <p className="text-[#6B7280] leading-relaxed">
              {t('legal.lastUpdated')}
            </p>
            <div className="space-y-4">
              <div>
                <h4 className="text-lg font-semibold text-[#111827] mb-2">{t('legal.termsSection1Title')}</h4>
                <p className="text-[#6B7280] leading-relaxed">
                  {t('legal.termsSection1Desc')}
                </p>
              </div>
              <div>
                <h4 className="text-lg font-semibold text-[#111827] mb-2">{t('legal.termsSection2Title')}</h4>
                <p className="text-[#6B7280] leading-relaxed">
                  {t('legal.termsSection2Desc')}
                </p>
              </div>
              <div>
                <h4 className="text-lg font-semibold text-[#111827] mb-2">{t('legal.termsSection3Title')}</h4>
                <p className="text-[#6B7280] leading-relaxed">
                  {t('legal.termsSection3Desc')}
                </p>
              </div>
              <div>
                <h4 className="text-lg font-semibold text-[#111827] mb-2">{t('legal.termsSection4Title')}</h4>
                <p className="text-[#6B7280] leading-relaxed">
                  {t('legal.termsSection4Desc')}
                </p>
              </div>
            </div>
          </div>
        );
      case 'cookies':
        return (
          <div className="space-y-6">
            <h3 className="text-2xl font-bold text-[#111827]">{t('legal.cookiePolicy')}</h3>
            <p className="text-[#6B7280] leading-relaxed">
              {t('legal.lastUpdated')}
            </p>
            <div className="space-y-4">
              <div>
                <h4 className="text-lg font-semibold text-[#111827] mb-2">{t('legal.cookiesSection1Title')}</h4>
                <p className="text-[#6B7280] leading-relaxed">
                  {t('legal.cookiesSection1Desc')}
                </p>
              </div>
              <div>
                <h4 className="text-lg font-semibold text-[#111827] mb-2">{t('legal.cookiesSection2Title')}</h4>
                <p className="text-[#6B7280] leading-relaxed">
                  {t('legal.cookiesSection2Desc')}
                </p>
              </div>
              <div>
                <h4 className="text-lg font-semibold text-[#111827] mb-2">{t('legal.cookiesSection3Title')}</h4>
                <p className="text-[#6B7280] leading-relaxed">
                  {t('legal.cookiesSection3Desc')}
                </p>
              </div>
            </div>
          </div>
        );
      case 'data':
        return (
          <div className="space-y-6">
            <h3 className="text-2xl font-bold text-[#111827]">{t('legal.dataProtection')}</h3>
            <p className="text-[#6B7280] leading-relaxed">
              {t('legal.lastUpdated')}
            </p>
            <div className="space-y-4">
              <div>
                <h4 className="text-lg font-semibold text-[#111827] mb-2">{t('legal.dataSection1Title')}</h4>
                <p className="text-[#6B7280] leading-relaxed">
                  {t('legal.dataSection1Desc')}
                </p>
              </div>
              <div>
                <h4 className="text-lg font-semibold text-[#111827] mb-2">{t('legal.dataSection2Title')}</h4>
                <p className="text-[#6B7280] leading-relaxed">
                  {t('legal.dataSection2Desc')}
                </p>
              </div>
              <div>
                <h4 className="text-lg font-semibold text-[#111827] mb-2">{t('legal.dataSection3Title')}</h4>
                <p className="text-[#6B7280] leading-relaxed">
                  {t('legal.dataSection3Desc')}
                </p>
              </div>
              <div>
                <h4 className="text-lg font-semibold text-[#111827] mb-2">{t('legal.dataSection4Title')}</h4>
                <p className="text-[#6B7280] leading-relaxed">
                  {t('legal.dataSection4Desc')}
                </p>
              </div>
            </div>
          </div>
        );
      default:
        return null;
    }
  };

  return (
    <section id="legal" className="py-16 md:py-24 bg-gradient-to-br from-gray-50 to-blue-50/30">
      <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-8">
        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-white/60 backdrop-blur-xl border border-white/20 shadow-lg rounded-full mb-4 md:mb-6">
            <Icon name="FileText" size={20} color="#0025cc" />
            <span className="text-sm md:text-base font-medium text-[#0025cc]">{t('legal.badge')}</span>
          </div>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-[#111827] mb-4">
            {t('legal.title')}
          </h2>
          <p className="text-base md:text-lg text-[#6B7280] max-w-2xl mx-auto">
            {t('legal.subtitle')}
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-4 gap-6">
          <div className="lg:col-span-1">
            <div className="bg-white/40 backdrop-blur-xl border border-white/20 rounded-2xl p-4 shadow-lg">
              {legalSections?.map((section) => (
                <button
                  key={section?.id}
                  onClick={() => setActiveSection(section?.id)}
                  className={`w-full flex items-center gap-3 px-4 py-3 rounded-xl transition-all duration-200 mb-2 ${
                    activeSection === section?.id
                      ? 'bg-[#0025cc] text-white shadow-md'
                      : 'text-[#6B7280] hover:bg-gray-100'
                  }`}
                >
                  <Icon name={section?.icon} size={20} color={activeSection === section?.id ? '#FFFFFF' : '#6B7280'} />
                  <span className="font-medium text-sm">{section?.label}</span>
                </button>
              ))}
            </div>
          </div>

          <div className="lg:col-span-3">
            <div className="bg-white/40 backdrop-blur-xl border border-white/20 rounded-2xl p-8 md:p-12 shadow-lg">
              {renderContent()}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default LegalSection;